var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content" },
    [
      _c("text-area-row", {
        attrs: {
          disabled: _vm.measuredTarget.isPrefilled,
          title: "SummaryReport.Results.Meter.Target",
          id: "measuredtargetname_" + _vm.targetIndex,
          required: true,
          maxLength: 500,
          rows: 5
        },
        model: {
          value: _vm.measuredTarget.targetName,
          callback: function($$v) {
            _vm.$set(_vm.measuredTarget, "targetName", $$v)
          },
          expression: "measuredTarget.targetName"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: "SummaryReport.Results.Meter.Change",
          id: "meterchange_" + _vm.targetIndex,
          required: true,
          maxLength: 750,
          rows: 7
        },
        model: {
          value: _vm.measuredTarget.change,
          callback: function($$v) {
            _vm.$set(_vm.measuredTarget, "change", $$v)
          },
          expression: "measuredTarget.change"
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.measuredTarget.meters, function(meter, index) {
        return [
          _c(
            "div",
            {
              key: "meter-title-" + index,
              staticClass: "d-flex align-items-center"
            },
            [
              _c(
                "h5",
                { staticClass: "my-0" },
                [
                  _c("plain-text-control", {
                    attrs: {
                      doNotUseResources: "",
                      noMargin: "",
                      title:
                        _vm.$t("SummaryReport.Results.Meter.Meter") +
                        " " +
                        (index + 1)
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.measuredTarget.meters.length > 1
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-link btn-contrast ",
                      attrs: {
                        type: "button",
                        "aria-label":
                          _vm.$t("SummaryReport.Results.DeleteMeter") +
                          " " +
                          (index + 1) +
                          " " +
                          _vm.$t("Accessibility.ConfirmDeleteMeter")
                      },
                      on: {
                        click: function($event) {
                          return _vm.deleteMeter(index)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-trash-alt fa-lg align-middle"
                      })
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("meter-control", {
            key: "meter-" + index,
            attrs: {
              meter: meter,
              meterIndex: index,
              targetIndex: _vm.targetIndex
            }
          })
        ]
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary my-2",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.addMeter()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("SummaryReport.Results.AddMeter")))]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }